<app-alert
  [message]="alertMessage"
  [show]="showAlert"
  [showCancel]="showCancel"
  [showConfirm]="showConfirm"
  (closed)="showAlert = false"
  (confirmed)="onAlertClosed(true)"
>
</app-alert>
<div class="carousel-container">
  <div class="carousel">
    <button class="arrow left" (click)="prev()">‹</button>
    <img
      [src]="getImageUrlByCarouselUrls(index)"
      class="slide"
      alt="Imagem do carrossel"
    />
    <button class="arrow right" (click)="next()">›</button>
  </div>

  <div class="w-100 m-t-16 m-b-0 description-wrapper">
    <mat-form-field
      appearance="outline"
      class="w-100 no-subscript description-field"
      color="primary"
    >
      @if (showDescriptionLabel) {
        <mat-label class="d-block">Descricao</mat-label>
      }
      <input
        matInput
        type="text"
        [placeholder]="descriptionPlaceholder"
        [(ngModel)]="description"
        (ngModelChange)="addDescriptionToCurrentImage($event)"
      />
    </mat-form-field>
  </div>

  <div class="upload-area">
    <button mat-icon-button (click)="openUploadModal()">
      <i-tabler name="circle-plus"></i-tabler>
    </button>
    @if (carouselUrls[index]) {
      <button mat-icon-button (click)="delete(index)">
        <i-tabler name="trash"></i-tabler>
      </button>
    }
  </div>
</div>
